export const visit = (vm, at) => {
at({ "en": { "priceComponents": { "pricePerMonth": "{{price}}/mo", "pricePerMonthPerSeat": "{{price}}/mo/seat", "pricingLabel": "{{name}} pricing", "subtexts": { "startsAt": "Starts at" } } } });
};